module.exports = __webpack_public_path__ + "static/media/ic_football_formation_cloth_home.51796376.png";